function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import { cloneElements, blockClickEvents, toggleActiveClassOnClick } from './header-utils';
var NON_ACTIVE_SECTION_CSS_SELECTOR = 'is-non-active-section';
var IS_VISIBLE = 'is-visible';
var IS_ACTIVE = 'is-active';
var IS_CURRENT = 'is-current';
var HAS_CHILDREN = 'has-children';
var HeaderNavigation = /*#__PURE__*/function (_WDHComponent) {
  function HeaderNavigation(className) {
    var _this;
    _classCallCheck(this, HeaderNavigation);
    _this = _callSuper(this, HeaderNavigation, [className]);
    _this.isMobileState = false;
    _this.onActiveClassToggled = _this.onActiveClassToggled.bind(_this);
    return _this;
  }
  _inherits(HeaderNavigation, _WDHComponent);
  return _createClass(HeaderNavigation, [{
    key: "init",
    value: function init(component) {
      this.decorateItemsWithChildren(component, '.level1, .level2, .level3, .level4', HAS_CHILDREN);
      this.decorateActiveItems(component, '.level1, .level2, .level3, .level4', IS_ACTIVE);
      this.decorateActiveItems(component, '.level1, .level2, .level3, .level4', IS_CURRENT);
      toggleActiveClassOnClick(component, '.level2 > a', IS_ACTIVE, this.onActiveClassToggled);
      blockClickEvents(component, '.level2.has-children > a, .level3.has-children > a');
      this.nonActiveSections = cloneElements(component, '.level1:not(.is-active) > a', NON_ACTIVE_SECTION_CSS_SELECTOR);
      this.clonedActiveSecondLevel = cloneElements(component, '.level1.is-active ul');
    }
  }, {
    key: "decorateItemsWithChildren",
    value: function decorateItemsWithChildren(component, targetCssSelector, cssClassName) {
      var _this2 = this;
      var liTagList = this.getNodesFromSelector(targetCssSelector, component);
      liTagList.forEach(function (liTag) {
        var ulTag = _this2.getNodesFromSelector('ul', liTag);
        if (ulTag.length > 0) {
          liTag.classList.add(cssClassName);
          liTag.classList.add("num-children-".concat(ulTag[0].children.length));
        }
      });
    }
  }, {
    key: "decorateActiveItems",
    value: function decorateActiveItems(component, targetCssSelector, cssClassName) {
      var liTagList = this.getNodesFromSelector(targetCssSelector, component);
      var currentUrl = window.location.href.split("?")[0];
      liTagList.forEach(function (liTag) {
        var aTag = liTag.querySelector('a');
        var aHref = aTag.href;
        if (currentUrl.startsWith(aHref)) {
          if (!liTag.classList.contains("has-children")) {
            if (currentUrl === aHref) {
              liTag.classList.add(cssClassName);
            }
          } else {
            liTag.classList.add(cssClassName);
          }
        }
      });
    }
  }, {
    key: "onActiveClassToggled",
    value: function onActiveClassToggled() {
      if (this.isMobileState) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: "isMobile",
    set: function set(value) {
      this.isMobileState = value;
    }
  }, {
    key: "isVisible",
    set: function set(value) {
      this.components.forEach(function (component) {
        if (value) {
          component.classList.add(IS_VISIBLE);
        } else {
          component.classList.remove(IS_VISIBLE);
        }
      });
    }
  }, {
    key: "getNonActiveSections",
    value: function getNonActiveSections() {
      return this.nonActiveSections;
    }
  }, {
    key: "getActiveSecondLevel",
    value: function getActiveSecondLevel() {
      return this.clonedActiveSecondLevel && this.clonedActiveSecondLevel.length ? this.clonedActiveSecondLevel[0] : null;
    }
  }, {
    key: "getCurrentFirstLevel",
    value: function getCurrentFirstLevel() {
      var component = this.components[0];
      if (component) {
        return component.querySelector('.level1.is-current');
      }
      return null;
    }
  }]);
}(WDHComponent);
export default HeaderNavigation;